__turbopack_context__.v({
  "accordionSlideOverwrite": "registrationComplete-module-scss-module__LfTjzW__accordionSlideOverwrite",
  "cancellation": "registrationComplete-module-scss-module__LfTjzW__cancellation",
  "fadeIn": "registrationComplete-module-scss-module__LfTjzW__fadeIn",
  "fadeOut": "registrationComplete-module-scss-module__LfTjzW__fadeOut",
  "image": "registrationComplete-module-scss-module__LfTjzW__image",
  "registrationComplete": "registrationComplete-module-scss-module__LfTjzW__registrationComplete",
  "scaleIn": "registrationComplete-module-scss-module__LfTjzW__scaleIn",
  "scaleOut": "registrationComplete-module-scss-module__LfTjzW__scaleOut",
  "subtitle": "registrationComplete-module-scss-module__LfTjzW__subtitle",
  "text": "registrationComplete-module-scss-module__LfTjzW__text",
  "textContainer": "registrationComplete-module-scss-module__LfTjzW__textContainer",
  "zoomIn": "registrationComplete-module-scss-module__LfTjzW__zoomIn",
  "zoomOut": "registrationComplete-module-scss-module__LfTjzW__zoomOut",
});
